module.exports = __webpack_public_path__ + "static/BITAS2-f3c15c8aceb6ab8054f1f3c67f3e1444.png";